


























































































































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import EssayTextInput from '@/components/EssayTextInput.vue';
import EssayPhotoInput from '@/components/EssayPhotoInput.vue';
import MobilePhotoInput from '@/components/MobilePhotoInput.vue';
import EssayReplyModel from '@/dex-shared/models/EssayReplyModel';

export default Vue.extend({
  components: {
    EssayTextInput,
    EssayPhotoInput,
    MobilePhotoInput,
  },
  data() {
    return {
      subsections: [
        {
          title: 'Digitar',
        },
        {
          title: 'Enviar foto',
        },
      ],
      active: 0,
    };
  },
  computed: {
    ...mapGetters({
      essayByPosition: 'essayByPosition',
      userEssayCredits: 'userEssayCredits',
    }),
    essay(): EssayReplyModel {
      return this.essayByPosition(
        this.$route.params.subjectSlug,
        +this.$route.params.position - 1,
      );
    },
  },
  methods: {
    isActive(i: number) {
      if (i == this.active) {
        return 'st-active';
      }
    },
    makeActive(i: number) {
      this.active = i;
    },
    sentEssay() {
      this.$emit('sentEssay');
    },
    noCredits(balance) {
      return balance < 1;
    },
  },
});
